import React, { useState, useEffect, useRef, useMemo } from 'react';

interface ChatMessage {
  id: number;
  username: string;
  game: string;
  amount: number;
  currency: string;
}

const ChatBox: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const currentUserIndexRef = useRef(0);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Mock data với danh sách users luân phiên
  const usernames = useMemo(() => [
    "anhchangcodon", "baotapchaybo", "cuongphongthan", "dochoigankteam", "emgaixinhdep", "fantaheadshot",
    "gaubongcute", "hoangtuonline", "imlangchoem", "jamevietnam", "khongbietchoi", "lanhluongroi",
    "meoconchaybo", "nguoichoimoi", "oanhkieu123", "phanlamgame", "quangprovip", "roimotphat",
    "sieubotvn", "thichanban", "uminhchienthan", "vudieubongtoi", "xauxi_999", "yeuemnhieunhe",
    "zorrovn", "banhayvl", "caythau_dem", "dococau_bai", "emyeuanh", "fullcombo",
    "ganhteam_", "headshotonly", "iconroi", "jamepro", "khongthuaai", "lamgamecungtoi",
    "motminhchientranh", "nguoibimat", "oimayroi", "phanlamgame_88", "quangvippro", "roi1phatchet",
    "sieubot_69", "thichchoigame", "umayroi", "vuiquadi", "xongroi", "yeuem_420",
    "zzzsleep", "banroi_1shot",
    "allintrongdem", "banhmykhong", "choivuila9", "daica_888", "emkhongngu",
    "furyplayer", "gamedethuong", "hiepsibai", "idolthulang", "jackpotmoi",
    "kiemchutixiu", "locphat99", "maymanhomnay", "nhatkiem_01", "ongtrumxanh",
    "playercodon", "quaytayto", "rolltoanwin", "songdeyeu", "thangdam24h"
  ], []);
  const games = useMemo(() => ["GG88"], []);
  
  const mockMessages: ChatMessage[] = useMemo(() => usernames.map((username, index) => ({
    id: index + 1,
    username: username,
    game: games[Math.floor(Math.random() * games.length)],
    amount: Math.floor(Math.random() * 500000000) + 10000000,
    currency: "VNĐ"
  })), [usernames, games]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    // Load initial 6 messages
    setMessages(mockMessages.slice(0, 6));
    
    // Auto add new messages every 1 second với users chạy tuần tự
    const interval = setInterval(() => {
      const currentUser = usernames[currentUserIndexRef.current];
      const randomGame = games[Math.floor(Math.random() * games.length)];
      const newMessage = {
        id: Date.now(),
        username: currentUser,
        game: randomGame,
        amount: Math.floor(Math.random() * 500000000) + 10000000,
        currency: "VNĐ"
      };
      
      setMessages(prev => {
        // Giữ tối đa 6 messages, xóa message cũ nhất
        const newMessages = [...prev, newMessage];
        return newMessages.length > 6 ? newMessages.slice(-6) : newMessages;
      });
      
      // Chuyển sang user tiếp theo, quay lại đầu nếu hết danh sách
      currentUserIndexRef.current = (currentUserIndexRef.current + 1) % usernames.length;
    }, 1000);

    return () => clearInterval(interval);
  }, [usernames, games, mockMessages]);

  const formatAmount = (amount: number): string => {
    return amount.toLocaleString('vi-VN');
  };

  return (
    <div className="chat-box-container">
      <div className="chat-box-wrapper">
        <img 
          src="/assets/bg-frame.png" 
          alt="Chat Box" 
          className="chat-box-image"
        />
        <div className="chat-box-content">
          <div className="chat-box-messages">
            {messages.map((message) => (
              <div key={message.id} className="chat-message">
                <div className="message-content">
                  <div className="message-text">
                    <span className="username">{message.username}</span>
                    <span className="game-info"> đã thắng tại {message.game}</span>
                  </div>
                  <div className="message-amount">
                    <span className="amount">{formatAmount(message.amount)}</span>
                    <span className="currency">{message.currency}</span>
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBox;
